// Animation
import { motion } from 'framer-motion'

// Utils
import { Join } from '../../lib/utils'

export function Spotlight({
  children = null,
  className = 'size-256 opacity-10',
  color = 'from-blue-500',
  overflow = true,
  initial = { opacity: 0, x: 0, y: 20 },
  whileInView = { opacity: 1, x: 0, y: 0 },
  viewport = { once: true },
  transition = { duration: 0.6, delay: 0.6 },
}: {
  children?: React.ReactNode
  className?: string
  color?: string
  overflow?: boolean
  initial?: { opacity: number; x: number; y: number }
  whileInView?: { opacity: number; x: number; y: number }
  viewport?: { once: boolean }
  transition?: { duration: number; delay: number }
}) {
  return (
    <motion.div
      initial={initial}
      whileInView={whileInView}
      viewport={viewport}
      transition={transition}
      className={Join(
        'absolute bg-radial via-transparent to-transparent',
        color,
        className,
      )}
    >
      <div
        className={Join(
          'relative size-full',
          overflow ? 'overflow-hidden' : 'overflow-visible',
        )}
      >
        {children}
      </div>
    </motion.div>
  )
}
